import { render, staticRenderFns } from "./PlayersListDialogComponent.vue?vue&type=template&id=2cb6ec30&scoped=true&"
import script from "./PlayersListDialogComponent.vue?vue&type=script&lang=ts&"
export * from "./PlayersListDialogComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb6ec30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
